import { render, staticRenderFns } from "./patient-merge-confirm.vue?vue&type=template&id=cb978126&scoped=true&lang=pug&"
import script from "./patient-merge-confirm.vue?vue&type=script&lang=ts&"
export * from "./patient-merge-confirm.vue?vue&type=script&lang=ts&"
import style0 from "./patient-merge-confirm.vue?vue&type=style&index=0&id=cb978126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb978126",
  null
  
)

export default component.exports